import * as React from 'react';
import * as Redux from 'redux';
import { connect } from 'react-redux';
import _ from 'lodash';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import cn from 'classnames';
import { setSelectedTabNameAction } from './../../../actions/modules';
import 'react-tabs/style/react-tabs.css';

const tabNameIdxMap = {
    projects: 0,
    faults: 1,
    comments: 2,
    upload: 3,
    settings: 4,
}

const TabsContainer = (props) => {
    return (
        <Tabs
            style={{
                width: '100%',
                overflowY: 'auto',
                display: 'flex',
                flexDirection: 'column',
                height: '100%'
            }}
            onSelect={(i) => props.setSelectedTabName(_.invert(tabNameIdxMap)[i])}
            selectedIndex={tabNameIdxMap[props.selectedTabName]}
            >
            <TabList className={cn('react-tabs__tab-list', props.className)} >
                {props.children.filter(child => child !== null).map(child => {
                    return <Tab key={child.props.title}>
                        {child.props.title}
                    </Tab>
                })}
            </TabList>
            {props.children.filter(child => child !== null).map(child => 
                <TabPanel
                    key={child.props.title} 
                    style={{
                        height: '100%'
                    }}
                >
                    {child}
                </TabPanel>
            )}
        </Tabs>
    );
}

const mapStateToProps = state => ({
    selectedTabName: state.modules.get('selectedTabName'),
});

const mapDispatchToProps = dispatch => Redux.bindActionCreators({
    setSelectedTabName : setSelectedTabNameAction
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(TabsContainer)


// WEBPACK FOOTER //
// ./src/containers/content/tabsContainer/TabsContainer.jsx